import * as React from 'react';
import { FunctionComponent } from 'react';

import { FormControl } from '@mui/material';
import { FieldProps } from 'formik';

import BaseAutocomplete from '../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { convertToSentenceCase } from '../../../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import { ItemLabelModel } from '../../../../shared/components/dropdown/models/dropdown-props.model';
import { optionEquality } from '../../../../shared/utils/option-equality/option-equality.util';

interface FormikInputFieldProps extends FieldProps {
  label: string;
  options: ItemLabelModel[];
}

export const FormikSelectField: FunctionComponent<FormikInputFieldProps> = ({
  field,
  form,
  label,
  options,
}) => {
  const { name, onBlur } = field;
  const { touched, errors, setFieldValue } = form;

  const selectedOption =
    options.find(option => option.label === field.value) || null;

  return (
    <FormControl>
      <BaseAutocomplete
        multiple={false}
        disableClearable={false}
        freeSolo={false}
        id="status"
        value={selectedOption}
        onChange={(_, newValue) => {
          setFieldValue(name, newValue ? newValue.label : '');
        }}
        onBlur={onBlur}
        options={options}
        getOptionLabel={option => convertToSentenceCase(option.label)}
        isOptionEqualToValue={optionEquality}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            errors={errors}
            id={name}
            label={label}
            name={name}
            touched={touched}
          />
        )}
      />
    </FormControl>
  );
};
